import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const EasypayForm = ({ enabled, t }) => {
	return (
		<div>
			<Field name='merchantId' component={Input} required type='text' label={t('Easypay_MerchantId')} validate={enabled && validators.required} trimOnBlur />
			<Field name='secretKey' component={Input} required type='text' label={t('Easypay_SecretKey')} validate={enabled && validators.required} trimOnBlur />
			<Field name='expirationDays' component={Input} required type='text' label={t('Easypay_PaymentExpiration')} validate={enabled && validators.required} />
			<Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
			<Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
			<Field name='useSandbox' component={Checkbox} label={t('Easypay_UseSandbox')} help={t('PaymentMethod_UseSandbox_HelpText')} normalize={(v) => !!v} />
		</div>
	);
};


export default EasypayForm;